module.exports = __webpack_public_path__ + "assets/img/kv-fd5c5b4a.jpg";